export default __webpack_public_path__ + "static/iremia-e74c6ce3f4848a3e9c17670cc627ec4f.mp4";